module.exports = __webpack_public_path__ + "static/media/Copy.3dab28ee.svg";